module.exports = __webpack_public_path__ + "img/login_img.67532b04.png";